import React from 'react';
import Section from './Section';
import SafeIcon from '../common/SafeIcon';
import { FiMapPin, FiUsers, FiActivity } from 'react-icons/fi';

const RealExamples = () => {
  const examples = [
    {
      icon: FiMapPin,
      title: "Location Data",
      points: [
        "Apps track where you go daily, even when closed.",
        "This data is routinely sold to unregulated brokers.",
        "Used by insurers, advertisers, or others to profile your lifestyle and routines."
      ]
    },
    {
      icon: FiUsers,
      title: "Contacts Access",
      points: [
        "Some apps map your entire personal and professional network.",
        "This creates an intimate relationship graph.",
        "Can be exploited for sophisticated scams or social engineering."
      ]
    },
    {
      icon: FiActivity,
      title: "Behavioral Tracking",
      points: [
        "Apps monitor how you behave, what you read, and how you interact.",
        "Creates a psychological profile of your triggers.",
        "This can influence pricing, offers, and decisions you make."
      ]
    }
  ];

  return (
    <Section>
      <div className="mb-16 md:text-center">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4">
          Real-World Consequences
        </h2>
        <p className="text-xl text-zinc-600 max-w-2xl mx-auto">
          It's not theoretical. Here is exactly how standard app permissions translate into tangible risks.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {examples.map((ex, idx) => (
          <div key={idx} className="bg-white p-8 rounded-2xl border border-zinc-200 shadow-sm hover:shadow-md transition-shadow">
            <div className="w-12 h-12 bg-zinc-100 rounded-lg flex items-center justify-center mb-6">
              <SafeIcon icon={ex.icon} className="w-6 h-6 text-zinc-900" />
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-4">{ex.title}</h3>
            <ul className="space-y-3">
              {ex.points.map((point, i) => (
                <li key={i} className="flex items-start gap-2 text-zinc-600">
                  <span className="text-zinc-400 mt-1.5 text-xs">●</span>
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default RealExamples;